__webpack_require__.p = "/wp-content/themes/rebus-tailwind-twentythree/react/";